import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import { Tabs } from "antd";

import * as T from 'utils/types';
import ResearcherListTitle from "components/researcher/ResearcherListTitle";
import ProfileDescriptionBasicInfo from "components/researcher/ProfileDescriptionBasicInfo";
import {profilePgThunks} from "./profilePgSlice";

import ScopusTab from "./tabs/ScopusTab";
import GsPubTab from "./tabs/GsPubTab";
import SmtPubTab from "./tabs/SmtPubTab";
import CreationTab from "./tabs/CreationTab";

import Error500 from "components/errors/Error500";
import ErrorNotPublic from 'components/errors/ErrorNotPublic';
import ToHomeButton from "components/ToHomeButton";

import "./ProfilePg.css";

// Profile Page
export default () => {
    const [type, setType] = useState("scopus");
    const { randomID } = useParams<{ randomID: string }>();


    const {
        user
    } = useSelector((state: T.RootState) => state.authentication);

    // for the user who is using the app
    // if he is not public and he somehow use his own link http://.../profile/<random-id>
    // he needs to know the reason is he not being public
    if (randomID === user?.random_id && !(user?.show_to_public)) return <ErrorNotPublic />;


    const {
        researcher,
        status,
    } = useSelector((state: T.RootState) => state.profilePg);

    // School for the Contemporary Arts has ID of 3
    const isSCA = researcher?.departments?.map(dept => dept.id).includes('3')

    useEffect(() => {
        if (isSCA) {
            setType('creation')
        }
    }, [isSCA])

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(profilePgThunks.rResearcher({randomID}));
    }, [dispatch, randomID])


    if (status==="failed") {
        return <Error500 extra={<ToHomeButton/>}/>;
    }

    return <>
        {status === "succeeded" && researcher && (
            <>
                <ResearcherListTitle researcher={researcher} profilePage />
                <ProfileDescriptionBasicInfo researcher={researcher} />
            </>)}

        <Tabs activeKey={type} onChange={key => setType(key)}>
            <Tabs.TabPane
                tab={<span className="sub-heading-font">Scopus Publications</span>}
                key="scopus"
            >
                <ScopusTab/>
            </Tabs.TabPane>
            <Tabs.TabPane
                tab={<span className="sub-heading-font">Google Scholar</span>}
                key="gsPub"
            >
                <GsPubTab/>
            </Tabs.TabPane>
            <Tabs.TabPane
                tab={<span className="sub-heading-font">SFU Summit</span>}
                key="smtPub"
            >
                <SmtPubTab/>
            </Tabs.TabPane>
            <Tabs.TabPane
                tab={<span className="sub-heading-font">Research Creation</span>}
                key="creation"
            >
                <CreationTab />
            </Tabs.TabPane>
            {/* <Tabs.TabPane tab="Other Scholarly Works" key="other">
                <div className="profilePageTab">
                    Under construction &#128220; - Eventually we want SFU faculty members to be able to add other types of scholarly works. <a className="sfu-red-link" href="https://www.sfu.ca/research/research-expertise-engine-feedback" target="_blank" rel="noopener noreferrer">Your feedback is needed</a> to help us build this functionality.
                </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="SFU Summit" key="sfu-summit">
                <div className="profilePageTab">
                    Under construction &#127956; - We will be integrating with SFU Library’s Summit repository shortly.
                </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Preprints" key="preprints">
                <div className="profilePageTab">
                    Under construction &#128478; - We will be adding publications from ArXiv, BioRxiv and ChemRxiv servers here.
                </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Web of Science Publications" key="web-of-science">
                <div className="profilePageTab">
                    Under construction &#129514; - We will be adding publications from the Web of Science database here.
                </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Google Scholar" key="google-scholar">
                <div className="profilePageTab">
                    Under construction &#127891; - Publications listed on Google Scholar will be listed here.
                </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Innovation" key="innovation">
                <div className="profilePageTab">
                    Under construction &#x1f4a1; - We look forward to the SFU community’s suggestions regarding outputs and impact connected with Innovation, e.g. patents, start-ups, spinouts, social innovation, knowledge mobilization, etc.
                </div>
            </Tabs.TabPane> */}
        </Tabs>
    </>;
}
